import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo-head";
import { SEGMENT_BY_SLUG } from "@/lib/segments";
import SegmentRoute from "@/pages/SegmentRoute";

export const Route = createFileRoute("/agente-ia-seguro-de-vida")({
  head: () => buildHead({
    title: SEGMENT_BY_SLUG["agente-ia-seguro-de-vida"]!.metaTitle,
    description: SEGMENT_BY_SLUG["agente-ia-seguro-de-vida"]!.metaDescription,
    path: "/agente-ia-seguro-de-vida",
  }),
  component: () => <SegmentRoute slug="agente-ia-seguro-de-vida" />,
});
